<template>
  <div class="about-page">
    <div class="mobile-tab-selector" @click="showMobileMenu = !showMobileMenu">
      <span>{{ getCurrentSectionLabel }}</span>
      <i :class="['el-icon-arrow-down', {'el-icon-arrow-up': showMobileMenu}]"></i>
    </div>
    <div class="about-menu" :class="{'mobile-menu-active': showMobileMenu}">
      <router-link to="/about/about-lucky-lottery" class="menu-item" :class="{ active: $route.path === '/about/about-lucky-lottery' }" @click="closeMobileMenu">About Lucky Lottery</router-link>
      <router-link to="/about/responsible-play-program" class="menu-item" :class="{ active: $route.path === '/about/responsible-play-program' }" @click="closeMobileMenu">Responsible Play Program</router-link>
      <router-link to="/about/is-gambling-affecting-your-health" class="menu-item" :class="{ active: $route.path === '/about/is-gambling-affecting-your-health' }" @click="closeMobileMenu">Is Gambling Affecting Your Health</router-link>
      <router-link to="/about/problem-gambling-help" class="menu-item" :class="{ active: $route.path === '/about/problem-gambling-help' }" @click="closeMobileMenu">Problem Gambling Help</router-link>
      <router-link to="/about/player-security" class="menu-item" :class="{ active: $route.path === '/about/player-security' }" @click="closeMobileMenu">Player Security</router-link>
      <router-link to="/about/giving-back" class="menu-item" :class="{ active: $route.path === '/about/giving-back' }" @click="closeMobileMenu">Giving Back</router-link>
      <router-link to="/about/news" class="menu-item" :class="{ active: $route.path === '/about/news' }" @click="closeMobileMenu">News</router-link>
    </div>
    <div class="about-content">
      <!-- About Lucky Lottery -->
      <div v-if="$route.path === '/about/about-lucky-lottery'">
        <h1>Introducing Lucky Lottery - the destination for South Australia's Lotteries.</h1>

        <p>Say 'hello' to Lucky Lottery - South Australia's newest lottery which started in 2013. It now has 4 popular games under its wing - Lucky 5 ball, Lucky 8 ball, Lucky 10 ball and Lucky 20 ball.</p>

        <p>It is supported by the Tatts Group which has been in the Australian lottery business for more than 134 years. Tatts Group operates the official, government-regulated lotteries in Victoria, Tasmania, the Northern Territory, New South Wales, the Australian Capital Territory, Queensland and South Australia.</p>

        <div class="trusted-partners">
          <h2>Our Partners</h2>
          <div class="partner-logos">
            <img :src="require('@/assets/images/foot1.png')" alt="Age Verified">
            <img :src="require('@/assets/images/foot2.png')" alt="Verified & Secured">
            <img :src="require('@/assets/images/foot3.png')" alt="Tatts Group">
            <img :src="require('@/assets/images/foot4.png')" alt="Tatts">
            <img :src="require('@/assets/images/foot5.png')" alt="The Lott">
          </div>
        </div>

        <div class="responsible-gambling">
          <h2>Responsible Gambling</h2>
          <div class="resposible-content">
            <p>You know the score.<br>
            Stay in control.<br>
            Gamble responsibly.</p>
            <div class="responsible-logo">
              <router-link to="/about/responsible-play-program" class="responsible-play">
                RESPONSIBLE<br>PLAY >
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- Responsible Play Program -->
      <div v-if="$route.path === '/about/responsible-play-program'">
        <h1>Responsible Play</h1>
        
        <p>At Lucky Lottery, we sell and promote our games responsibly so they can be enjoyed by all players. We do this by complying with the South Australia Gambling Codes of Practice and therefore ensure that:</p>
        
        <ul class="bullet-list">
          <li>game rules and responsible gambling material are available at all retail agencies;</li>
          <li>a clock displaying the time of day is visible at all retail agencies;</li>
          <li>problem gambling referral advice is offered to players who have difficulty controlling the amount of money they spend on our games;</li>
          <li>intoxicated people cannot play our games, and we do not use alcohol to encourage play;</li>
          <li>cheques cannot be cashed as payment to play our games;</li>
          <li>all retail agency staff receive accredited responsible gambling training, including specialised training for staff aged less than 18 years; and</li>
          <li>refresher training on responsible gambling is conducted for our retail agency network at least every two years.</li>
        </ul>
        
        <p>In addition, within our Agency Compliance Program we visit each member of our retail agency network at least once each year to ensure that they too are complying with these Codes of Practice.</p>
        
        <p>Don't let the game play you. Stay in control. Gamble responsibly.</p>
        
        <h2>Responsible Gambling Links</h2>
        
        <ul class="bullet-list">
          <li>South Australia Gambling Codes of Practice</li>
          <li>Gambling Help Link - www.gamblinghelponline.org.au</li>
          <li>Problem gambling support advice is available to players</li>
        </ul>
      </div>

      <!-- Is Gambling Affecting Your Health -->
      <div v-if="$route.path === '/about/is-gambling-affecting-your-health'">
        <h1>Is Gambling Affecting Your Health?</h1>
        
        <p>If you think gambling might be affecting your health, take this simple test by answering the following questions as truthfully as you can:</p>
        
        <ol class="numbered-list">
          <li>Sometimes I've felt depressed or anxious after a session of gambling.</li>
          <li>Sometimes I've felt guilty about the way I gamble.</li>
          <li>When I think about it, gambling has sometimes caused me problems.</li>
          <li>Sometimes I've found it better not to tell others, especially my family, about the amount of time or money I spend gambling.</li>
          <li>I often find that when I stop gambling I've run out of money.</li>
          <li>Often I get the urge to return to gambling to win back losses from a past session.</li>
          <li>Yes, I have received criticism about my gambling in the past.</li>
          <li>Yes, I have tried to win money to pay debts</li>
        </ol>
        
        <p>If you scored four or more 'yes' answers, your gambling may be affecting your health at this time. To discuss concerns you may have, <a href="/about/problem-gambling-help">problem gambling help</a> is available.</p>
        
        <p>Source: 'Eight' Gambling Screen - Early Intervention Gambling Health Test</p>
        
        <p>Developed by Dr Sean Sullivan for the Problem Gambling Foundation of New Zealand and the Department of General Practice and Primary Health Care in the Auckland School of Medicine.</p>
      </div>

      <!-- Problem Gambling Help -->
      <div v-if="$route.path === '/about/problem-gambling-help'">
        <h1>Problem Gambling Help</h1>
        
        <p>If playing our games is no longer fun for you, or you are concerned about the playing behaviour of someone close to you, problem gambling information and counselling is available 24 hours a day, 365 days a year. Contact the Gambling Help Line on free call 1800 858 858, or visit www.gamblinghelponline.org.au for confidential advice and counselling.</p>
        
        <p>Lucky Lottery and its retail agency network are committed to the responsible promotion and conduct of lottery games to ensure a safe playing environment for customers. Find out more about Lucky Lottery's responsible play commitment by reading our 'Have Fun and Play it Safe' brochure.</p>
      </div>

      <!-- Player Security -->
      <div v-if="$route.path === '/about/player-security'">
        <h1>Player Security</h1>
        
        <p>Protecting the entitlements of players and ensuring the secure and correct payment of prizes remains of utmost importance to Lucky Lottery.</p>
        
        <p>The following lists reflect Lucky Lottery's commitment to protecting the interests of our players and ensuring the integrity of our games.</p>
        
        <h2>Prize claims</h2>
        
        <ul class="bullet-list">
          <li>Validation slips are provided to players to confirm status of ticket.</li>
          <li>Non-winning tickets are returned to customers.</li>
          <li>Any prizes over $5,000 can be claimed in person or via post accompanied with the Prize Claim form (preferably by registered post).</li>
          <li>Ex gratia prize claims can be lodged for lost or damaged unregistered tickets.</li>
          <li>Lucky Lottery Head Office offers secure prize payment, such as electronic funds transfer.</li>
        </ul>
        
        <h2>Player information</h2>
        
        <ul class="bullet-list">
          <li>Information dedicated to the prize claim process is available to all players.</li>
          <li>Player security measures are inherent in Lucky Lottery's practices.</li>
          <li>Problem gambling support advice is provided to players</li>
        </ul>
        
        <h2>Results availability</h2>
        
        <ul class="bullet-list">
          <li>Registered Division One prize winners are contacted by telephone.</li>
          <li>Game results broadcast on free-to-air television.</li>
          <li>Results are immediately published on Lucky Lottery website.</li>
          <li>Game results are available via an IVR (Interactive Voice Response) telephone system or by SMS.</li>
          <li>Latest Lucky 5 Ball, Lucky 8 Ball, Lucky 10 Ball and Lucky 20 Ball draw broadcasts on Lucky Lottery's website.</li>
        </ul>
      </div>

      <!-- Help pages -->
      <div v-if="$route.path === '/help/how-to-claim-prizes'">
        <h1>How to claim prizes</h1>
        
        <p>There are several ways you can claim a prize, including direct payment into your Bank Account, claiming through an Lucky Lottery Outlet, by mail, or claiming in person at Head Office.</p>
        
        <h2>For tickets purchased from retail outlets</h2>
        
        <ul class="bullet-list">
          <li>Prizes of up to $500 can be claimed at any Lucky Lottery Outlet.</li>
          <li>Prizes between $500 and $5,000 can be claimed at any Lucky Lottery Outlet (at the Retailer's discretion or up to their approved payout limit), in person from Head Office or by post with a Prize Claim Form.</li>
          <li>Prizes above $5,000 can be paid via cheque or Electronic Funds Transfer (EFT) in person at Head Office or by post with a Prize Claim Form.</li>
          <li>Division One prizes can be paid via cheque or EFT in person at Head Office or by post with a Prize Claim Form. These prizes are subject to a two-week provisional period before your payment can be made.</li>
        </ul>
        
        <h2>Claim in person</h2>
        
        <p>Depending on the value of the prize, claims can be made in person at your nearest Lucky Lottery Outlet or at Lucky Lottery Head Office.</p>
        
        <div class="address-block">
          <p>Lucky Lottery Head Office<br>
          328 Richmond Road<br>
          Marleston SA 5033<br>
          Opening hours: Monday – Friday, 8.30am – 4.30pm</p>
        </div>
        
        <p>To collect your prize in person at Lucky Lottery Head Office, you will need:</p>
        
        <ol class="numbered-list">
          <li>The original Lucky Lottery ticket</li>
          <li>Signature identification such as a Drivers Licence or Passport</li>
        </ol>
      </div>

      <!-- Default content for first option -->
      <div v-if="!isKnownRoute">
        <h1>About Lucky Lottery</h1>
        <p>Please select an option from the menu on the left to view related content.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      showMobileMenu: false,
      knownRoutes: [
        '/about/about-lucky-lottery',
        '/about/responsible-play-program',
        '/about/is-gambling-affecting-your-health',
        '/about/problem-gambling-help',
        '/about/player-security',
        '/about/giving-back',
        '/about/news',
        '/help/how-to-claim-prizes'
      ]
    }
  },
  computed: {
    isKnownRoute() {
      return this.knownRoutes.includes(this.$route.path)
    },
    getCurrentSectionLabel() {
      switch(this.$route.path) {
        case '/about/about-lucky-lottery': return 'About Lucky Lottery';
        case '/about/responsible-play-program': return 'Responsible Play Program';
        case '/about/is-gambling-affecting-your-health': return 'Is Gambling Affecting Your Health';
        case '/about/problem-gambling-help': return 'Problem Gambling Help';
        case '/about/player-security': return 'Player Security';
        case '/about/giving-back': return 'Giving Back';
        case '/about/news': return 'News';
        case '/help/how-to-claim-prizes': return 'How to Claim Prizes';
        default: return 'About Lucky Lottery';
      }
    }
  },
  methods: {
    closeMobileMenu() {
      this.showMobileMenu = false;
    }
  }
}
</script>

<style scoped>
.about-page {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 30px;
  box-sizing: border-box;
}

.mobile-tab-selector {
  display: none;
  padding: 15px;
  background-color: #ff69b4;
  color: white;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 15px;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 5px rgba(255, 105, 180, 0.3);
}

.about-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.menu-item {
  padding: 10px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.3s;
}

.menu-item:hover,
.menu-item.active {
  background-color: #ff69b4;
  color: white;
}

.about-content {
  background: white;
  border-radius: 8px;
  padding: 20px;
}

.about-content h1 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
}

.about-content h2 {
  font-size: 20px;
  color: #333;
  margin: 30px 0 15px;
}

.about-content h3 {
  font-size: 18px;
  color: #333;
  margin: 15px 0 10px;
}

.about-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.trusted-partners {
  margin-top: 40px;
}

.partner-logos {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 20px;
}

.partner-logos img {
  height: 60px;
}

.responsible-gambling {
  margin-top: 40px;
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
}

.resposible-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.resposible-content p {
  font-style: italic;
  margin-bottom: 0;
}

.responsible-play {
  display: inline-block;
  padding: 5px 15px;
  border: 1px solid #ff69b4;
  color: #ff69b4;
  text-decoration: none;
  text-align: center;
  font-size: 12px;
  line-height: 1.2;
}

/* Added styles */
.program-highlights ul,
.warning-signs ul,
.bullet-list {
  list-style-type: disc;
  margin-left: 20px;
  color: #666;
  line-height: 1.6;
}

.program-highlights li,
.warning-signs li,
.bullet-list li {
  margin-bottom: 10px;
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 20px;
}

.tool-item {
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
  border-left: 3px solid #ff69b4;
}

.tool-item h3 {
  color: #ff69b4;
  margin-top: 0;
}

.tool-item p {
  margin-bottom: 0;
}

.help-contacts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 20px;
}

.help-line {
  background-color: #fff8f8;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
}

.help-line h3 {
  color: #ff69b4;
  margin-top: 0;
}

.help-line p {
  margin-bottom: 5px;
}

.help-line p:last-child {
  margin-bottom: 0;
  font-size: 14px;
  color: #999;
}

.health-impacts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 20px;
}

.impact-item {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
}

.impact-item h3 {
  margin-top: 0;
  color: #333;
}

.impact-item p {
  margin-bottom: 0;
}

.self-assessment ol,
.numbered-list {
  margin-left: 20px;
  color: #666;
  line-height: 1.6;
}

.self-assessment li,
.numbered-list li {
  margin-bottom: 10px;
}

.assessment-result {
  margin-top: 20px;
  padding: 15px;
  background-color: #fff8f8;
  border-radius: 8px;
  border-left: 4px solid #ff69b4;
  font-weight: bold;
}

@media (max-width: 768px) {
  .about-page {
    grid-template-columns: 1fr;
    padding: 15px;
    gap: 15px;
  }
  
  .mobile-tab-selector {
    display: flex;
  }
  
  .about-menu {
    display: none;
    position: absolute;
    z-index: 10;
    background: white;
    width: calc(100% - 30px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
    border-radius: 4px;
    margin-top: -10px;
  }
  
  .about-menu.mobile-menu-active {
    display: flex;
  }
  
  .about-content {
    padding: 20px 15px;
  }
  
  .tools-grid, 
  .help-contacts, 
  .health-impacts {
    grid-template-columns: 1fr;
  }
  
  .resposible-content {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .resposible-content p {
    margin-bottom: 15px;
  }
}

@media (max-width: 576px) {
  .about-page {
    padding: 10px;
  }
  
  .about-content {
    padding: 15px 10px;
  }
  
  .partner-logos {
    justify-content: center;
  }
  
  .about-content h1 {
    font-size: 22px;
  }
  
  .about-content h2 {
    font-size: 18px;
  }
  
  .about-content h3 {
    font-size: 16px;
  }
  
  .about-content p, 
  .bullet-list li, 
  .numbered-list li {
    font-size: 14px;
  }
  
  .bullet-list, 
  .numbered-list {
    padding-left: 0;
    margin-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue